<template>
    <div class="animated fadeIn">
        <table
            class="kgr-table kgr-table--block table-groups table-employees kgr-table--striped printable"
        >
            <thead>
                <tr class="kgr-table__row">
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t("club.exam.title") }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t("club.exam.type") }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t("club.exam.sport") }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t("Prüfungsdatum") }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t("Teilergebnisse") }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t("club.exam.result.status") }}
                    </th>
                    <th
                        v-if="canEdit"
                        class="kgr-table__cell kgr-table__cell--headline kgr-table__cell--actions kgr-hidden-print"
                    ></th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="exam in exams"
                    :key="exam.id"
                    class="kgr-table__row"
                >
                    <td class="kgr-table__cell">
                        {{ exam.title }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ exam.type }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ exam.sport }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ exam.examDate }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ examPartResultStatus(exam) }}
                    </td>
                    <td class="kgr-table__cell">
                        <span style="position: relative; top: 5px;">
                            <kgr-icon
                                v-if="exam.status === 'failure'"
                                icon-class="close"
                                small
                            />
                            <kgr-icon
                                v-else-if="exam.status === 'pending'"
                                icon-class="clock"
                                small
                            />
                            <kgr-icon
                                v-else-if="exam.status === 'success'"
                                icon-class="check"
                                small
                            />
                        </span>
                        {{ $t("club.exam.result.status." + exam.status) }}
                    </td>
                    <td
                        v-if="canEdit"
                        class="kgr-table__cell kgr-table__cell--actions kgr-hidden-print"
                    >
                        <a
                            class="kgr-table__action"
                            :href="examEditUrl(exam)"
                        >
                            <kgr-icon icon-class="edit" />
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import Icon from '../common/icon/Icon.vue';

export default {
    components: {
        'kgr-icon': Icon
    },
    props: {
        exams: {
            type: Array,
            required: true
        },
        examEditUrl: {
            type: Function,
            required: true
        },
        canEdit: {
            type: Boolean,
            required: true,
            default: false,
        }
    },
    methods: {
        examPartResultStatus(exam) {
            const count = exam.examPartResults.length;
            if (count === 0) {
                return '-';
            }
            const successful = exam.examPartResults.filter((el) => el.status === 'success').length;
            return successful + '/' + count;
        }
    }
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
